exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-4f2f9579] {\n  position: relative;\n}\n.text.text-truncate[data-v-4f2f9579] {\n  padding-right: 60px;\n}\n.link-when-compressed[data-v-4f2f9579] {\n  position: absolute;\n  right: 0;\n}\n", ""]);

// exports
